import { Component } from "react"

/* Translate */
import { t } from "../translates/translate"

/* REST API */
import { studios as getStudios, launch } from "../api/PitBoard"

/* Components */
import { pushToast } from "./Toast"

/* Icons */
import { CloseIcon } from "./Icons"

/* Modal */
import Modal from "react-modal"


/* THE MOUNTED HOST — THE MENU OPENS PITBOARD THROUGH IT */
let host = null


/* OPEN PITBOARD FROM ANYWHERE — CALLED RIGHT IN A CLICK, SO THE NEW TAB IS NOT BLOCKED */
export const openPitBoard = () => {

    /* Check Host */
    if (!host) {
        return
    }

    host.open()
}


/* Component PitBoard — a confirmation with the studios: a single one is chosen already, several wait for a choice */
class PitBoard extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            status: "idle",
            studios: [],
            selected: 0,
            waiting: false,
        }
    }

    componentDidMount = () => {
        host = this
    }

    componentWillUnmount = () => {
        host = null
    }

    /* Load Studios */
    load = () => {

        this.setState({ status: "loading" })

        return getStudios().then((response) => {
            if (response && response.status === 200) {

                /* Selection — a single studio is chosen at once, several wait for a choice */
                const list = response.data.studios
                this.setState({ status: "ok", studios: list, selected: list.length === 1 ? list[0].id : 0 })
                return list
            }

            this.setState({ status: "error" })
            return null
        }).catch(() => {
            this.setState({ status: "error" })
            return null
        })
    }

    /* Open — always a confirmation first, a click on the menu never leaves the panel by itself */
    open = () => {

        /* The List Is Asked Every Time — the access may have changed */
        this.setState({ visible: true, selected: 0 })
        this.load()
    }

    /* Close */
    close = () => this.setState({ visible: false })

    /* Go To A Studio — the tab is opened first, the link of 60 seconds arrives into it */
    go = () => {

        /* Fields */
        const { studios, selected, waiting } = this.state
        const studio = studios.find((item) => item.id === selected)

        /* Check Selection */
        if (!studio || waiting) {
            return
        }

        /* The Tab — inside the click, otherwise the browser blocks it */
        const tab = window.open("", "_blank")

        this.setState({ waiting: true })

        launch({ studioID: studio.id }).then((response) => {
            if (response && response.status === 200) {

                /* Open */
                if (tab) {
                    tab.location.href = response.data.url
                }
                else {
                    window.location.href = response.data.url
                }

                this.setState({ visible: false })
                return
            }

            /* Error */
            if (tab) {
                tab.close()
            }

            pushToast({ text: (response && response.data && response.data.message) || t("pitboard.error"), type: "error" })
        }).catch(() => {

            if (tab) {
                tab.close()
            }

            pushToast({ text: t("pitboard.error"), type: "error" })
        }).finally(() => {
            this.setState({ waiting: false })
        })
    }

    /* Draw Body */
    _body = () => {

        /* Fields */
        const { status, studios, selected, waiting } = this.state

        /* Loading */
        if (status === "loading" || status === "idle") {
            return <div className="pitboard--empty"><div className="pitboard--loading" /></div>
        }

        /* Error */
        if (status === "error") {
            return <div className="pitboard--empty">{t("pitboard.error")}</div>
        }

        /* No Studios */
        if (studios.length === 0) {
            return <div className="pitboard--empty">{t("pitboard.noStudios")}</div>
        }

        return (
            <div className="pitboard--list">
                {studios.map((item) =>
                    <div key={item.id} onClick={() => waiting ? null : this.setState({ selected: item.id })} className={`pitboard--studio ${selected === item.id ? "selected" : ""}`}>
                        <div className="pitboard--studio-mark">{String(item.name || "S").slice(0, 1).toUpperCase()}</div>
                        <div className="pitboard--studio-text">
                            <div className="pitboard--studio-name">{item.name}</div>
                            {item.slug ? <div className="pitboard--studio-slug">{item.slug}</div> : null}
                        </div>
                        <div className="pitboard--studio-check">{selected === item.id ? "✓" : ""}</div>
                    </div>
                )}
            </div>
        )
    }

    render = () => {

        const { visible, selected, waiting } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={this.close}
                className="pitboard--modal"
                overlayClassName="pitboard--overlay"
                closeTimeoutMS={200}
            >

                <div className="pitboard--modal-header">

                    <div>
                        <h2>{t("pitboard.title")}</h2>
                        <p>{t("pitboard.subtitle")}</p>
                    </div>

                    <div onClick={this.close} className="pitboard--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                <div className="pitboard--modal-body">
                    {this._body()}
                </div>

                <div className="pitboard--modal-footer">
                    <div onClick={this.close} className="pitboard--button ghost">{t("pitboard.close")}</div>
                    <div onClick={this.go} className={`pitboard--button primary ${!selected || waiting ? "disabled" : ""}`}>
                        {waiting ? <div className="pitboard--loading small light" /> : t("pitboard.go")}
                    </div>
                </div>

            </Modal>
        )
    }

}

export default PitBoard
